export class Login {
   'phone' = '';
}